// @flow

import React from 'react';
import { connect } from 'react-redux';
import RemoveFiltersButtonComponent from './removeFiltersButton';
import { removeAllFilters, hasFilters as hasFiltersSelector } from '../../../store/assortment';
import { getRemoveFiltersButtonText } from '../../../store/assortmentSettings';

type DispatchProps = {|
  onRemoveFilters: Function,
|};

type StateProps = {|
  hasFilters: boolean,
  removeFiltersButtonText: string,
|};

type Props = {|
  ...DispatchProps,
  ...StateProps,
|};

const RemoveFiltersButton = ({
  onRemoveFilters,
  hasFilters,
  removeFiltersButtonText,
}: Props) => (
  <RemoveFiltersButtonComponent
    disabled={!hasFilters}
    onClick={onRemoveFilters}
    removeFiltersButtonText={removeFiltersButtonText}
  />
);

const mapStateToProps = (state): StateProps => ({
  hasFilters: hasFiltersSelector(state),
  removeFiltersButtonText: getRemoveFiltersButtonText(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  onRemoveFilters: () => dispatch(removeAllFilters()),
});

export default connect<Props, any, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(RemoveFiltersButton);
